import { CheckIcon } from 'lucide-react'

export const TrialLiveHeading = () => (
  <>
    <span className="flex size-10 items-center justify-center rounded-full bg-brand/10 text-brand-deep">
      <CheckIcon aria-hidden className="size-5" />
    </span>
    <h1 className="text-2xl font-semibold tracking-tight text-balance sm:text-[28px]">
      Your CounselPro trial is ready.
    </h1>
  </>
)
